import React from "react";
import { useNavigate } from "react-router-dom";
import { Stethoscope, ChevronRight } from "lucide-react";
import Layout from "../components/Layout";
import BackButton from "../components/BackButton";
import { getBooking, setBooking } from "../lib/bookingState";

export default function AgendarTipo() {
  const navigate = useNavigate();
  const booking = getBooking();

  if (!booking.patient_id) {
    navigate("/agendar", { replace: true });
    return null;
  }

  function escolherConsulta() {
    setBooking({
      tipo_agendamento: "consulta",
      procedimento_id: 100,
      procedimento_nome: "CONSULTA",
      especialidade_id: undefined,
      especialidade_nome: undefined,
      profissional_id: undefined,
      profissional_nome: undefined,
      data_hora: undefined,
      local_id: undefined,
    });

    navigate("/agendar/especialidade");
  }

  return (
    <Layout>
      <BackButton to="/agendar" />

      <div className="fade-up">
        <h1 className="text-2xl sm:text-3xl tracking-tight font-bold text-slate-900" style={{ fontFamily: "Manrope" }}>
          O que deseja agendar?
        </h1>
        <p className="text-slate-600 mt-2 text-sm">
          No momento, o agendamento online está disponível para consultas.
        </p>
      </div>

      <div className="mt-6 space-y-3">
        <button
          onClick={escolherConsulta}
          className="w-full bg-white border border-slate-200 rounded-2xl p-5 text-left hover:shadow-md transition-all flex items-center gap-4"
        >
          <div className="w-12 h-12 rounded-xl bg-[#00357C] text-white flex items-center justify-center">
            <Stethoscope size={22} />
          </div>

          <div className="flex-1">
            <div className="font-semibold text-slate-900">Consulta</div>
            <p className="text-sm text-slate-600 mt-1">
              Agendamento com médico especialista.
            </p>
          </div>

          <ChevronRight size={18} className="text-slate-400" />
        </button>
      </div>
    </Layout>
  );
}